import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../Assets/Images/logo.png';
import { Link, NavLink } from 'react-router-dom';
import { DropdownItem, DropdownMenu, Form, NavItem } from 'react-bootstrap';
import { PageSummary_SearchRequest } from '../Models/Model';
import { PageType } from '../Models/Enum';
import { SimpleResponse } from '../Models/ResponseModel';
import pageService from '../Services/pageService';

function NavigatorPage() {

  const [Categories, setCategories] = useState([]);




  useEffect(() => {
    getCardData();

  }, []);

  const getCardData = async () => {

    let req = new PageSummary_SearchRequest();
    req.PageTypeID = PageType.FruitCategory;
    try {
      let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
      if (resp.HasError) {
        return;
      }
      setCategories(resp.Result);
    } catch (e) {

    }
  }
  

  return (
    <Navbar collapseOnSelect expand="lg pt-3 pb-3">
      <Container>
        <Navbar.Brand href="/">
          <img className='w-100' src={logo} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav " >
          <Nav className="mx-auto align-items-lg-center custom-nav">
            <NavDropdown  title="Our Fruits" id="collapsible-nav-dropdown" className='d-lg-none'>
              <NavDropdown.Item eventKey="1"  as={NavLink} to="/Products">Fruit Listing </NavDropdown.Item>
              {Categories != undefined && Categories.length > 0 && Categories.map((item, index) => (
                      <NavDropdown.Item key={index} as={NavLink} to={item.URL} eventKey={index+"_item"}>{item.Title} </NavDropdown.Item>
                    ))}
              {/* <NavDropdown.Item as={NavLink} to="/Products/Mango/Ratnagiri-Alphonso-Mangoes">Mango</NavDropdown.Item> */}
            </NavDropdown>

            <div className="dropdown d-none d-lg-block">
              <button className="dropbtn">Our Fruits</button>
              <div className="dropdown-content" >

                <NavDropdown.Item as={NavLink} to="/Products">Fruit Listing </NavDropdown.Item>

                {Categories != undefined && Categories.length > 0 && Categories.map((item, index) => (
                      <NavDropdown.Item key={index} as={NavLink} to={item.URL} >{item.Title} </NavDropdown.Item>
                    ))}              
              </div>
            </div>

            <div className="dropdown d-none d-lg-block">
              <button className="dropbtn">About Us</button>
              <div className="dropdown-content">
                <NavDropdown.Item  as={NavLink} to="/AboutUs/Technology"> Technology </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/AboutUs/Sustainability">Sustainability</NavDropdown.Item>

              </div>
            </div>

            <NavDropdown title="About Us" id="collapsible-nav-dropdown" className='d-lg-none'>
              <NavDropdown.Item eventKey="2" as={NavLink} to="/AboutUs/Technology">Technology</NavDropdown.Item>
              <NavDropdown.Item eventKey="3" as={NavLink} to="/AboutUs/Sustainability">Sustainability</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/Traceability" eventKey="4" className='nav-link'>Traceability</Nav.Link>
            <Nav.Link as={Link} to="/Contacts" eventKey="5" className='nav-link'>Contact Us</Nav.Link>
            <Nav.Link as={Link}  to="/WhereToBuy" eventKey="6" className='nav-link'>Where To Buy</Nav.Link>
          </Nav>
          <Nav>
            <NavDropdown title="Shop Online" id="collapsible-nav-dropdown" className='shop-btn'>
              <NavDropdown.Item as={Link} to="https://amazon.in/superplum" target='_blank'>Amazon</NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="https://www.zeptonow.com/search?query=superplum" target='_blank'>Zepto</NavDropdown.Item> */}
              <NavDropdown.Item as={Link} to="https://shop.superplum.com/collections/frontpage" target='_blank'>Shop NCR</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="https://shop.superplum.com/collections/benagaluru-fruits" target='_blank'>Shop Bengaluru</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>



/* <Navbar collapseOnSelect expand="lg" >
    <Container>
      <Navbar.Brand href="#home">React-Bootstrap</Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link href="#features">Features</Nav.Link>
          <Nav.Link href="#pricing">Pricing</Nav.Link>
          <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">
              Another action
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href="#action/3.4">
              Separated link
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
        <Nav>
          <Nav.Link href="#deets">More deets</Nav.Link>
          <Nav.Link eventKey={2} href="#memes">
            Dank memes
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar> */



  );

}

export default NavigatorPage; 